import regExp from './regExp'
import api from '@/api'
export function validateEnCompany(rule, value, callback) {
  if (rule.required || value!='') {
    if (value) {
      if (regExp.ComNameEn.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}
export function validComName(data) {
  const reg = regExp.ComName
  return reg.test(data)
}
export function validComEName(data) {
  const reg = regExp.ComNameEn
  return reg.test(data)
}
export function validateComName(rule, value, callback) {
  if (rule.required || value!='') {
    if (value) {
      if (regExp.ComName.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}

export function validatePassword(rule, value, callback) {
  if (rule.required || value!='') {
    if ( value!='') {
      if (regExp.password.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}

export function validateChineseZipCode(rule, value, callback) {
  if (rule.required || value!='') {
    if ( value!='') {
      if (regExp.enZipCode.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}

/**
 * @param {string}} Address
 * @returns {Boolean}
 */
 export function validAddress(data) {
  const reg = regExp.addressCn
  return reg.test(data)
}
/**
 * @param {string}} zipCode
 * @returns {Boolean}
 */
 export function validZipCode(data) {
  const reg = regExp.ZipCode
  return reg.test(data)
}
/**
 * @param {string}} webUrl
 * @returns {Boolean}
 */
 export function validWebUrl(data) {
  const reg = regExp.webUrl
  return reg.test(data)
}


export function validTel(data) {
  const reg = regExp.Tel
  return reg.test(data)
}

/**
* email
*
*/
export function validEmail(data) {
const reg = regExp.Email
return reg.test(data)
}
/**
* 
* @param {string} str name
* @returns 
*/
export function validName(data) {
const reg = regExp.Name
const reg2 = regExp.enName
return (reg.test(data) || reg2.test(data))
}
/**
* 
* @param {string} str mobile
* @returns 
*/
export function validMobile(data) {
const reg = regExp.Mobile
return reg.test(data)
}
/**
* 
* @param {string} str idCard
* @returns 
*/
export function validIDcard(data) {
const reg = regExp.regCId
return reg(data)
}
/**
* 
* @param {string} str rank
* @returns 
*/
export function validRank(data) {
const reg = regExp.regCheckRank
return reg.test(data)
}
/**
* 
* @param {string} str dept
* @returns 
*/
export function validDept(data) {
const reg = regExp.Depart
return reg.test(data)
}

export function validateCoutry(rule, value, callback) {
  let _arr = value.split('-');
  if( _arr[0]){
      if( _arr[0] == '中国' ){
        if( !_arr[1]  || _arr[1] ==''){
          callback(new Error('请选择省份'));
        }else if(  !_arr[2] ||  _arr[2] == ''){
          callback(new Error('请选择城市'));
        }else{
          callback();
        }
      }else{
        callback();
      }
  }else{
    callback(new Error('请选择国家'));
  }

}

export function validateMobile(rule, value, callback) {
  if (rule.required || value!='') {
    if ( value!='') {
      if (regExp.regCheckCnMobile.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}


export function validateCoutry01(rule, value, callback) {
  
  let _arr = value.split('-');
  if(rule.required || _arr[0] ){
      if( _arr[0]){
          if(  _arr[0].indexOf("中国大陆") > -1 ){
            if( !_arr[1]  || _arr[1] ==''){
              callback(new Error('请选择省份'));
            }else if(  !_arr[2] ||  _arr[2] == ''){
              callback(new Error('请选择城市'));
            }else{
              callback();
            }
          }else{
            callback();
          }
      }else{
        callback(new Error('请选择国家'));
      }
  }else{
    callback();
  }


}
export function validateTel(rule, value, callback) {
  let _arr = value.split('-');
  if( !_arr[0] ){
    callback(new Error('请填写国家区号'));
  }else if(!_arr[1]){
    callback(new Error('请填写省份区号'));
  }else if(!_arr[2]){
    callback(new Error('请填电话号码'));
  }else{
    callback();
  }

}

//验证电话或传真
export function validateTelele(rule, value, callback) {
  if (rule.required || value!='') {
    if ( value ) {
      if (regExp.Tel.exec(value) || regExp.enTel.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
  
}

export function validateEmail(rule, value, callback) {
  if (rule.required || value!='') {
    if ( value ) {
      if (regExp.Email.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}

export function validateNumber(rule, value, callback){
  if (Number.isInteger(Number(value)) && Number(value) > 0) {
    callback();
  } else {
    callback(new Error('请输入大于0的整数'));
  }
}

export function validateAddress(rule, value, callback){
  if (rule.required || value!='') {
    if (value) {
      if (regExp.addressCn.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}

export function validateName(rule, value, callback){
  if (rule.required || value!='') {
    if ( value!='') {
      if (regExp.Name.exec(value) || regExp.enName.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}

export function validateRank(rule, value, callback){
  if (rule.required || value!='') {
    if ( value!='') {
      if (regExp.Rank.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}

export function validateWebUrl(rule, value, callback){
  if (rule.required || value!='') {
    if ( value!='') {
      if (regExp.webUrl.exec(value)) {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    } else {
      callback(new Error(rule.message))
    }
  } else {
    callback()
  }
}

export function validateIDcard(data) {
  const reg = regExp.regCId
  return reg(data)
}

export function realNameVerification(that, name, idCard) {
  return new Promise((resolve, reject) => {
    api.GetValidationToken().then(restoken =>{
      if (restoken.data.Status === 'OK') {
        api.CheckValidation({
          Name: name,
          IDNum: idCard,
          Code: sessionStorage.getItem('realcode'),
          APPKey: restoken.data.AppTokenKey,
          AppValue: restoken.data.AppTokenValue
        }).then(valres=>{
          if(valres.data.Status ==='OK'){
            if(valres.data.result ==='false'){
              that.$notify.error({
                title: '错误',
                message: '您输入的姓名与身份证号不一致',
                offset: 100
                
              });
              that["loading"] = false;
            }
            resolve(valres.data.result)
          } else {
            that.$notify.error({
              title: '错误',
              message: valres.data.Msg
            });
            that["loading"] = false;
          }
        })
      } else {
        that.$alert('token获取失败，请重新获取', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            api.GetValidationToken().then(restoken =>{
              if (restoken.data.Status === 'OK') {
                api.CheckValidation({
                  Name: name,
                  IDNum: idCard,
                  Code: sessionStorage.getItem('realcode'),
                  APPKey: restoken.data.AppTokenKey,
                  AppValue: restoken.data.AppTokenValue
                }).then(valres=>{
                  if(valres.data.Status ==='OK'){
                    if(valres.data.result ==='false'){
                      that.$notify.error({
                        title: '错误',
                        message: '您输入的姓名与身份证号不一致'
                      });
                      that["loading"] = false;
                    }
                    resolve(valres.data.result)
                  } else {
                    that.$notify.error({
                      title: '错误',
                      message: valres.data.Msg
                    });
                    that["loading"] = false;
                  }
                })
              } else {
                that.$notify.error({
                  title: '错误',
                  message: valres.data.Msg
                });
                that["loading"] = false;
              }
            })
          }
        });
      }
    })
  })
}
export default {
   
}
